import React, { useEffect } from 'react';
import './EmployeeApplications.css';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';

const EmployeeApplications = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const apmRoleNameGet = localStorage.getItem("role");

  // useEffect(() => {
  //   if (location.pathname === '/employeeApplications') {
  //     navigate('submitted'); // default route on initial load
  //   }

  // }, [location.pathname, navigate]);
  useEffect(() => {
    if (location.pathname === '/employeeApplications') {
      navigate('submitted', { replace: true }); // replace keeps history clean
    }
  }, [location.pathname, navigate]);

  return (
    <div className="application-container">
      <div className="profile-header">
        <h2 className="para-text">Employee Profiles</h2>
      </div>

      <div className="link-bar-changes-myapp">

        <NavLink
          to="draft"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          Draft / Pending Profiles
        </NavLink>

        <NavLink
          to="submitted"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          Submitted Profiles
        </NavLink>

        <NavLink
          to="resubmitApplications"
          className={({ isActive }) => (isActive ? 'active-link' : '')}
        >
          Resubmit List
        </NavLink>

        {(apmRoleNameGet !== "APM" && apmRoleNameGet !== "PM" && apmRoleNameGet !== "APM Zone"&&apmRoleNameGet!=='APM OPERATIONS') && (
          <NavLink
            to="onBoardingPending"
            className={({ isActive }) => (isActive ? 'active-link' : '')}
          >
            Joining Pending Applications
          </NavLink>
        )}

      </div>

      <div className="line-width">
        <hr />
      </div>

      <div className="nested-route-content">
        <Outlet />
      </div>
    </div>
  );
};

export default EmployeeApplications;
